var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from "react";
import { useDispatch } from "react-redux";
import styled from "styled-components";
import { Typography } from "@material-ui/core";
import { SpaciousTypography } from "./styleComponents";
import { useTypedSelector } from "../state/store";
import * as quizAnswerActions from "../state/quizAnswer/actions";
import LaterQuizItemAddition from "./LaterQuizItemAddition";
import MarkdownText from "./MarkdownText";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import ThemeProviderContext from "../contexes/themeProviderContext";
import ClickableChoiceButton from "./ClickableChoiceButton";
var QuestionContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  font-size: 1.25rem;\n  margin-right: 0.25rem;\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  font-size: 1.25rem;\n  margin-right: 0.25rem;\n"])));
var ChoicesContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  padding: 15px 10px;\n  background: #f5f5f5;\n  border-radius: 7px;\n  ", "\n  ", "\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  padding: 15px 10px;\n  background: #f5f5f5;\n  border-radius: 7px;\n  ", "\n  ", "\n"])), function (_a) {
  var onlyOneItem = _a.onlyOneItem;
  return onlyOneItem && "width: 100%";
}, function (_a) {
  var onlyOneItem = _a.onlyOneItem,
    providedStyles = _a.providedStyles;
  return providedStyles && onlyOneItem && providedStyles;
});
var CentralizedOnSmallScreenTypography = styled(Typography)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  position: relative;\n  top: 2px;\n  @media only screen and (max-width: 600px) {\n    text-align: center;\n  }\n"], ["\n  position: relative;\n  top: 2px;\n  @media only screen and (max-width: 600px) {\n    text-align: center;\n  }\n"])));
var AttentionIcon = styled(FontAwesomeIcon)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 30px !important;\n"], ["\n  font-size: 30px !important;\n"])));
var ItemContent = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-bottom: 10px;\n  > div:first-of-type {\n    display: flex;\n    justify-content: space-between;\n    flex-direction: ", ";\n  }\n  ", "\n"], ["\n  margin-bottom: 10px;\n  > div:first-of-type {\n    display: flex;\n    justify-content: space-between;\n    flex-direction: ", ";\n  }\n  ", "\n"])), function (_a) {
  var direction = _a.direction;
  return direction;
}, function (_a) {
  var providedStyles = _a.providedStyles;
  return providedStyles;
});
var LeftBorderedDiv = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  border-left: 6px solid ", ";\n  box-sizing: border-box;\n  padding: 3px;\n  padding: 0.5rem 0 0.5rem 0.5rem;\n  margin-top: 1rem;\n  margin-bottom: 5px !important;\n  p:nth-of-type(1) {\n    display: none;\n  }\n  p:nth-of-type(2) {\n    margin-top: -0.25rem;\n    padding: 0 0 0 0.5rem;\n  }\n  ", "\n"], ["\n  display: flex;\n  border-left: 6px solid ", ";\n  box-sizing: border-box;\n  padding: 3px;\n  padding: 0.5rem 0 0.5rem 0.5rem;\n  margin-top: 1rem;\n  margin-bottom: 5px !important;\n  p:nth-of-type(1) {\n    display: none;\n  }\n  p:nth-of-type(2) {\n    margin-top: -0.25rem;\n    padding: 0 0 0 0.5rem;\n  }\n  ", "\n"])), function (_a) {
  var correct = _a.correct;
  return correct ? "#047500" : "#DB0000";
}, function (_a) {
  var onlyOneItem = _a.onlyOneItem;
  return onlyOneItem && "width: 70%;";
});
var LeftAlignedMarkdownText = styled(MarkdownText)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  text-align: left;\n"], ["\n  text-align: left;\n"])));
var justADiv = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject([""], [""])));
var MultipleChoice = function (_a) {
  var item = _a.item;
  var themeProvider = React.useContext(ThemeProviderContext);
  var quiz = useTypedSelector(function (state) {
    return state.quiz;
  });
  var quizDisabled = useTypedSelector(function (state) {
    return state.quizAnswer.quizDisabled;
  });
  var answer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer;
  });
  if (!quiz) {
    return React.createElement("div", null);
  }
  var itemAnswer = answer.itemAnswers.find(function (ia) {
    return ia.quizItemId === item.id;
  });
  if (!itemAnswer && !quizDisabled) {
    return React.createElement(LaterQuizItemAddition, {
      item: item
    });
  }
  var onlyOneItem = quiz.items.length === 1;
  var options = item.options;
  var direction = "row";
  var questionWidth = 5;
  var optionWidth = "auto";
  if (onlyOneItem) {
    var maxOptionLength = Math.max.apply(Math, options.map(function (option) {
      return option.title.length;
    }));
    direction = "column";
  }
  return React.createElement("div", {
    role: "group",
    "aria-label": item.title
  }, React.createElement(ItemContent, {
    direction: direction,
    providedStyles: themeProvider.multipleChoiceItemContentStyles
  }, React.createElement("div", null, React.createElement(ItemInformation, {
    item: item,
    itemAnswer: itemAnswer,
    onlyOneItem: onlyOneItem,
    questionWidth: questionWidth
  }), React.createElement(ChoicesContainer, {
    direction: direction,
    onlyOneItem: onlyOneItem,
    providedStyles: themeProvider.optionContainerStyles
  }, options.sort(function (o1, o2) {
    return o1.order - o2.order;
  }).map(function (option, index) {
    return React.createElement(Option, {
      key: option.id,
      option: option,
      optionWidth: optionWidth,
      shouldBeGray: index % 2 === 0
    });
  }))), React.createElement(FeedbackPortion, {
    item: item
  })));
};
var ItemInformation = function (_a) {
  var onlyOneItem = _a.onlyOneItem,
    item = _a.item;
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var answerLocked = userQuizState && userQuizState.status === "locked";
  var languageInfo = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  if (!languageInfo) {
    return React.createElement("div", null);
  }
  var multipleChoiceLabels = languageInfo.multipleChoice;
  var selectOptionsLabel = answerLocked ? "" : item.multi ? multipleChoiceLabels.chooseAllSuitableOptionsLabel : onlyOneItem ? multipleChoiceLabels.selectCorrectAnswerLabel : "";
  var title = item.title,
    body = item.body;
  return React.createElement(QuestionContainer, null, !onlyOneItem && title && React.createElement(LeftAlignedMarkdownText, {
    Component: SpaciousTypography,
    removeParagraphs: true,
    variant: "subtitle1",
    id: "item-question-" + title
  }, title), body && React.createElement(MarkdownText, null, body), selectOptionsLabel && React.createElement(SelectOptionsLabelTypography, {
    variant: "subtitle1",
    variantMapping: {
      subtitle1: "p"
    },
    onlyOneItem: onlyOneItem
  }, selectOptionsLabel));
};
var SelectOptionsLabelTypography = styled(Typography)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  color: 6b6b6b;\n  ", "\n"], ["\n  color: 6b6b6b;\n  ", "\n"])), function (_a) {
  var onlyOneItem = _a.onlyOneItem;
  return onlyOneItem && "margin: 0 auto 1rem;";
});
var Option = function (_a) {
  var option = _a.option,
    shouldBeGray = _a.shouldBeGray;
  var themeProvider = React.useContext(ThemeProviderContext);
  var dispatch = useDispatch();
  var items = useTypedSelector(function (state) {
    return state.quiz.items;
  });
  var item = items.find(function (i) {
    return i.id === option.quizItemId;
  });
  var quizAnswer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer;
  });
  var userQuizState = useTypedSelector(function (state) {
    return state.user.userQuizState;
  });
  var languageLabels = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  var displayFeedback = useTypedSelector(function (state) {
    return state.feedbackDisplayed;
  });
  var quizDisabled = useTypedSelector(function (state) {
    return state.quizAnswer.quizDisabled;
  });
  if (!item || !languageLabels) {
    return React.createElement("div", null, "Cannot find related item or language");
  }
  var itemAnswer = quizAnswer.itemAnswers.find(function (ia) {
    return ia.quizItemId === item.id;
  });
  var onlyOneItem = items.length === 1;
  var text = option;
  if (!itemAnswer && !quizDisabled) {
    return React.createElement("div", null, "Answer cannot be retrieved");
  }
  var handleOptionChange = function (optionId) {
    return function () {
      dispatch(quizAnswerActions.changeChosenOption(item.id, optionId));
    };
  };
  var optionAnswers = itemAnswer && itemAnswer.optionAnswers;
  var answerLocked = userQuizState && userQuizState.status === "locked";
  var lengthOfSelectedOption = itemAnswer === null || itemAnswer === void 0 ? void 0 : itemAnswer.optionAnswers.length;
  var optionIsSelected = optionAnswers && optionAnswers.some(function (oa) {
    return oa.quizOptionId === option.id;
  }) || false;
  if (!displayFeedback) {
    return React.createElement(OptionWrapper, {
      onlyOneItem: onlyOneItem,
      shouldBeGray: shouldBeGray,
      providedStyles: themeProvider.optionWrapperStyles
    }, React.createElement(ClickableChoiceButton, {
      onlyOneItem: onlyOneItem,
      selected: !!optionIsSelected,
      revealed: false,
      correct: false,
      state: optionIsSelected,
      onClick: handleOptionChange(option.id),
      disabled: !optionIsSelected && lengthOfSelectedOption >= 5,
      "aria-pressed": optionIsSelected
    }, React.createElement(MarkdownText, {
      Component: justADiv,
      removeParagraphs: true
    }, text.title)));
  }
  var clickOptions = answerLocked ? {} : {
    onClick: handleOptionChange(option.id)
  };
  if (onlyOneItem) {
    return React.createElement(React.Fragment, null, React.createElement(OptionWrapper, {
      onlyOneItem: onlyOneItem,
      shouldBeGray: shouldBeGray,
      providedStyles: themeProvider.optionWrapperStyles
    }, React.createElement(ClickableChoiceButton, __assign({
      revealed: true,
      state: optionIsSelected,
      onlyOneItem: onlyOneItem,
      selected: !!optionIsSelected,
      correct: option.correct,
      disabled: !optionIsSelected && lengthOfSelectedOption >= 5
    }, clickOptions, {
      "aria-selected": optionIsSelected,
      "aria-label": text.title + "-" + (option.correct ? "correct" : "incorrect")
    }), React.createElement(MarkdownText, {
      Component: justADiv,
      removeParagraphs: true
    }, text.title))));
  }
  return React.createElement(React.Fragment, null, React.createElement(OptionWrapper, {
    onlyOneItem: onlyOneItem,
    shouldBeGray: shouldBeGray
  }, React.createElement(ClickableChoiceButton, __assign({
    revealed: true,
    state: optionIsSelected,
    onlyOneItem: onlyOneItem,
    selected: !!optionIsSelected,
    correct: option.correct,
    disabled: !optionIsSelected && lengthOfSelectedOption >= 5
  }, clickOptions, {
    "aria-selected": optionIsSelected,
    "aria-label": text.title + "-" + (option.correct ? "correct" : "incorrect")
  }), React.createElement(MarkdownText, {
    Component: justADiv,
    removeParagraphs: true
  }, text.title))));
};
var FeedbackPortion = function (_a) {
  var item = _a.item;
  var themeProvider = React.useContext(ThemeProviderContext);
  var items = useTypedSelector(function (state) {
    return state.quiz.items;
  });
  var quizAnswer = useTypedSelector(function (state) {
    return state.quizAnswer.quizAnswer;
  });
  var languageLabels = useTypedSelector(function (state) {
    return state.language.languageLabels;
  });
  var feedbackDisplayed = useTypedSelector(function (state) {
    return state.feedbackDisplayed;
  });
  if (!feedbackDisplayed) {
    return React.createElement("div", {
      style: {
        display: "none"
      }
    });
  }
  if (!item || !languageLabels) {
    return React.createElement("div", null, "Cannot find related item or language");
  }
  var itemAnswer = quizAnswer.itemAnswers.find(function (ia) {
    return ia.quizItemId === item.id;
  });
  if (!itemAnswer) {
    return React.createElement("div", null, "Cannot find related item answer");
  }
  var onlyOneItem = items.length === 1;
  var generalLabels = languageLabels.general;
  var optionAnswers = itemAnswer && itemAnswer.optionAnswers;
  var optionAnswer = optionAnswers[0];
  var selectedOption = item.options.find(function (o) {
    return o.id === optionAnswer.quizOptionId;
  });
  var feedbackMessage;
  if (item.usesSharedOptionFeedbackMessage && item.sharedOptionFeedbackMessage !== undefined) {
    feedbackMessage = item.sharedOptionFeedbackMessage;
  } else {
    var optionSuccess = selectedOption ? selectedOption.successMessage : undefined;
    var optionFailure = selectedOption ? selectedOption.failureMessage : undefined;
    var text = item;
    var successMessage = optionSuccess || text.successMessage || generalLabels.answerCorrectLabel;
    var failureMessage = optionFailure || text.failureMessage || generalLabels.answerIncorrectLabel;
    feedbackMessage = itemAnswer.correct ? successMessage : failureMessage;
  }
  var correct = itemAnswer.correct && true || false;
  var ThemedDiv = themeProvider.feedbackMessage;
  var FeedbackDiv = ThemedDiv || LeftBorderedDiv;
  if (ThemedDiv) {
    return React.createElement(ThemedDiv, {
      correct: correct,
      onlyOneItem: onlyOneItem,
      message: correct ? generalLabels.answerCorrectLabel : generalLabels.answerIncorrectLabel
    }, React.createElement(CentralizedOnSmallScreenTypography, {
      variant: "body1"
    }, feedbackMessage));
  }
  return React.createElement(FeedbackDiv, {
    correct: correct,
    onlyOneItem: onlyOneItem
  }, React.createElement(CentralizedOnSmallScreenTypography, {
    variant: "body1"
  }, React.createElement(AttentionIcon, {
    icon: faExclamationCircle
  })), React.createElement(CentralizedOnSmallScreenTypography, {
    variant: "body1"
  }, feedbackMessage));
};
var OptionWrapper = styled.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (_a) {
  var onlyOneItem = _a.onlyOneItem,
    shouldBeGray = _a.shouldBeGray,
    providedStyles = _a.providedStyles;
  return onlyOneItem ? "\n      display: flex;\n      justify-content: center;\n      background-color: #F5F5F5;\n      " + providedStyles + "\n    " : "\n      margin-left: 1rem;\n      ";
});
export default MultipleChoice;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;